import { FormatType } from "./format-type.js";
import { splitTextInArray } from "./array.js";
import {
  formatBold,
  formatBoldLetterToNormal,
  matchIsUnicodeBold,
} from "./bold.js";
import {
  formatBoldItalicLetterToNormal,
  matchIsUnicodeBoldItalic,
} from "./bold-italic.js";
import { compose } from "./compose.js";
import {
  formatItalic,
  formatItalicLetterToNormal,
  matchIsUnicodeItalic,
} from "./italic.js";
import { matchIsNumber } from "./number.js";
import { formatUppercase } from "./uppercase.js";

export function getUnicodeLetter(letter) {
  return letter.codePointAt(0);
}

export function matchIsTextUppercase(text) {
  return text === text.toUpperCase();
}

export function matchIsTextEmpty(text) {
  return text.trim() === "";
}

export function matchIsCharacterANormalLetter(char) {
  return /[a-zA-Z]/.test(char[0]);
}
export function getFileNameFromUrl(url) {
  const fullFileName = url.split("/").pop();

  return fullFileName;
}

export function matchIsTextUnknown(text) {
  const textSplitted = splitTextInArray(text);
  return textSplitted.every((letter) => {
    const unicode = getUnicodeLetter(letter);
    return (
      !matchIsNumber(unicode) ||
      (!matchIsUnicodeBold(unicode) &&
        !matchIsUnicodeItalic(unicode) &&
        !matchIsUnicodeBoldItalic(unicode) &&
        !matchIsCharacterANormalLetter(letter))
    );
  });
}

export function formatNormal(text) {
  const textSplitted = splitTextInArray(text);
  const textSplittedFormatted = textSplitted.map((letter) => {
    return compose(
      formatBoldLetterToNormal,
      formatItalicLetterToNormal,
      formatBoldItalicLetterToNormal
    )(letter);
  });
  return textSplittedFormatted.join("");
}

export function formatTextByType(text, formatType) {
  if (formatType === FormatType.italic) {
    return formatItalic(text);
  }
  if (formatType === FormatType.bold) {
    return formatBold(text);
  }
  if (formatType === FormatType.normal) {
    return formatNormal(text);
  }
  if (formatType === FormatType.uppercase) {
    return formatUppercase(text);
  }
  return text;
}

export function getLastPathName(path) {
  const pathSegments = path
    .split("/")
    .filter((segment) => segment.trim() !== "");
  const lastSegment = pathSegments[pathSegments.length - 1];
  return lastSegment.replace(/-/g, " ");
}

export function formatVoiceNoteTitle(title) {
  if(title)
    return title.replace(/^"|"$/g, "");
  else
    return title;
}

export function formatVoiceNoteContent(content) {
  if(content)
    return content
      .split("\n")
      .map((line) => line.trim().replace(/^- /, ""))
      .filter(Boolean)
      .join("\n");
  else
    return content;
}

export function getYouTubeVideoId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
}
